var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmitMileston(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73,36H25.1c-3.3,0-6,2.7-6,6v32c0,3.3,2.7,6,6,6H73c3.3,0,6-2.7,6-6V42C79,38.7,76.3,36,73,36z M40.9,48.6 v22c0,1-0.7,1.9-1.7,1.9c0,0,0,0-0.1,0c-1,0-1.8-0.9-1.8-1.9v-22c-0.6-0.6-0.9-1.4-0.9-2.2c-0.1-1.5,1-2.8,2.5-2.9s2.8,1,2.9,2.5 c0,0.2,0,0.3,0,0.5C41.8,47.2,41.5,48,40.9,48.6L40.9,48.6z M62.4,62.4c0,0.3-0.2,0.6-0.4,0.8c-6.9,4.1-10.8-2.4-17.2-0.3 c-0.5,0.1-1-0.1-1.2-0.6c0-0.1,0-0.2,0-0.3V49.5c0-0.4,0.2-0.8,0.6-0.9c6.6-2.6,10.5,4.2,17.5,0.2c0.2-0.1,0.5-0.1,0.6,0.1 c0.1,0.1,0.1,0.2,0.1,0.3L62.4,62.4L62.4,62.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1,30h4c0.5,0,1-0.4,1-0.9c0,0,0-0.1,0-0.1v-3h14v3c0,0.5,0.4,1,0.9,1c0,0,0.1,0,0.1,0h4 c0.5,0,1-0.4,1-0.9c0,0,0-0.1,0-0.1v-3c0-3.3-2.7-6-6-6h-14c-3.3,0-6,2.7-6,6v3c0,0.5,0.4,1,0.9,1C37,30,37.1,30,37.1,30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitMileston);
export default __webpack_public_path__ + "static/media/SubmitMileston.fffc0781217c27fd8ba2d6345c329d55.svg";
export { ForwardRef as ReactComponent };